export default __webpack_public_path__ + "static/media/dino_showroom_start.be6fc59e.jpg";